"use client";

import { createContext, useContext } from "react";

/**
 * Store-wide wishlist kill switch (Settings → Products), exposed to client
 * components without prop-threading through every list path — the same shape
 * as StockDisplayProvider next door.
 *
 * This is a floor, not an override: when it is false the favourite control is
 * gone everywhere, and when it is true each surface still decides for itself
 * (the page builder's per-widget `show_wishlist`, for instance). Defaults to
 * true with no provider, so nothing disappears in contexts that don't wrap.
 */
const WishlistEnabledContext = createContext<boolean>(true);

export function WishlistEnabledProvider({
  value,
  children,
}: {
  value: boolean;
  children: React.ReactNode;
}) {
  return (
    <WishlistEnabledContext.Provider value={value}>
      {children}
    </WishlistEnabledContext.Provider>
  );
}

export function useWishlistEnabled(): boolean {
  return useContext(WishlistEnabledContext);
}
